import type { Broadcaster } from 'laravel-echo';
import { onScopeDispose } from 'vue';
import { echo } from '../echo';

type ReverbChannel = Broadcaster['reverb']['public'];
type NullChannel = Broadcaster['null']['public'];

export type UseEcho = {
    dispose: () => void;
    channel: (channel: string) => ReverbChannel|NullChannel;
    private: (channel: string) => ReverbChannel|NullChannel;
}
export function useEcho(): UseEcho {
    const channels: (ReverbChannel|NullChannel)[] = [];

    function dispose() {
        for(const channel of channels) {
            channel.unsubscribe();
        }
    }

    onScopeDispose(dispose);

    return {
        dispose,
        channel(channel: string) {
            if(!echo) return null as unknown as ReverbChannel;

            const instance = echo.channel(channel);

            instance.subscribe();

            channels.push(instance);

            return instance;
        },
        private(channel: string) {
            if(!echo) return null as unknown as ReverbChannel;

            const instance = echo.private(channel);

            instance.subscribe();

            channels.push(instance);

            return instance;
        }
    };
}